import React, { useEffect, useState } from "react";
import "./MissionPopup.css";

import { authFetch } from '../../HttpClient';

function MissionPopup({ client, onClose }) {
  const [modifications, setModifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [droitSoc, setDroitSoc] = useState([]);

  useEffect(() => {
    const fetchClient = async () => {
      setLoading(true);
      try {
        const response = await authFetch(`https://backend-myalfa.vercel.app/api/clients/${client.id}`
        );
        const data = await response.json();
        setModifications(data.modifSocietes || []);
        setDroitSoc(data.droitSoc || []);
      } catch (error) {
        console.error("Erreur lors du chargement des données client :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchClient();
  }, [client.id]);

  return (
    <div className="mission-overlay" onClick={onClose}>
      <div className="mission-popup" onClick={(e) => e.stopPropagation()}>
        <h3>
          {client.nom} (Client ID: {client.id})
        </h3>

        {loading ? (
          <div className="spinner"></div>
        ) : modifications.length === 0 && droitSoc.length === 0 ? (
          <p className="no-modif">Aucune modification trouvée.</p>
        ) : (
          <div className="modif-list">
            {modifications.map((modif, index) => (
              <div key={modif.id || index} className="modif-card">
                {modif.activeForme && (
                  <div className="modif-section">
                    <h5>Forme sociale</h5>
                    <p>
                      <span>Nouvelle forme :</span>{" "}
                      <strong>{modif.nouvelleFormeSociale || "—"}</strong>
                    </p>
                    <p>
                      <span>Commentaire :</span>{" "}
                      <strong>{modif.commentaireForme || "—"}</strong>
                    </p>
                  </div>
                )}

                {modif.activeSiege && (
                  <div className="modif-section">
                    <h5>Siège social</h5>
                    <p>
                      <span>Nouvelle adresse :</span>{" "}
                      <strong>{modif.adresseNouveauSiege || "—"}</strong>
                    </p>
                    <p>
                      <span>Commentaire :</span>{" "}
                      <strong>{modif.commentaireSiege || "—"}</strong>
                    </p>
                  </div>
                )}

                {modif.activeDateCloture && (
                  <div className="modif-section">
                    <h5>Date de clôture</h5>
                    <p>
                      <span>Nouvelle date :</span>{" "}
                      <strong>
                        {modif.nouvelleDateCloture?.split("T")[0] || "—"}
                      </strong>
                    </p>
                    <p>
                      <span>Commentaire :</span>{" "}
                      <strong>{modif.commentaireDate || "—"}</strong>
                    </p>
                  </div>
                )}

                {modif.activeDenomination && (
                  <div className="modif-section">
                    <h5>Dénomination</h5>
                    <p>
                      <span>Nouvelle dénomination :</span>{" "}
                      <strong>{modif.nouvelleDenomination || "—"}</strong>
                    </p>
                    <p>
                      <span>Commentaire :</span>{" "}
                      <strong>{modif.commentaireDenomination || "—"}</strong>
                    </p>
                  </div>
                )}

                {modif.activeObjetSocial && (
                  <div className="modif-section">
                    <h5>Objet social</h5>
                    <p>
                      <span>Modification :</span>{" "}
                      <strong>{modif.modificationObjet || "—"}</strong>
                    </p>
                    <p>
                      <span>Nouvelles activités :</span>{" "}
                      <strong>{modif.nouvellesActivites || "—"}</strong>
                    </p>
                    <p>
                      <span>Commentaire :</span>{" "}
                      <strong>{modif.commentaireObjet || "—"}</strong>
                    </p>
                  </div>
                )}

                {modif.activeCapital && (
                  <div className="modif-section">
                    <h5>Capital</h5>
                    <p>
                      <span>Nouveau capital :</span>{" "}
                      <strong>{modif.nouveauCapital || "—"}</strong>
                    </p>
                    <p>
                      <span>Commentaire :</span>{" "}
                      <strong>{modif.commentaireCapital || "—"}</strong>
                    </p>
                  </div>
                )}

                {modif.activeDirigeant && (
                  <div className="modif-section">
                    <h5>Dirigeant</h5>
                    <p>
                      <span>Type de modification :</span>{" "}
                      <strong>{modif.typeModificationDirigeant || "—"}</strong>
                    </p>
                    <p>
                      <span>Commentaire :</span>{" "}
                      <strong>{modif.commentaireDirigeant || "—"}</strong>
                    </p>
                  </div>
                )}
              </div>
            ))}
            {droitSoc.length > 0 && (
              <div className="droit-soc-list">
                <h4>Cessions de droits sociaux</h4>
                {droitSoc.map((droit, index) => (
                  <div key={droit.id || index} className="modif-card">
                    <p>
                      <strong>Cédant :</strong> {droit.cedant || "—"}
                    </p>
                    <p>
                      <strong>Cessionnaire :</strong>{" "}
                      {droit.cessionnaire || "—"}
                    </p>
                    <p>
                      <strong>Nombre de droits :</strong>{" "}
                      {droit.nombreDeDroit || "—"}
                    </p>
                    <p>
                      <strong>Prix de cession :</strong>{" "}
                      {droit.prixCession || "—"}
                    </p>
                    <p>
                      <strong>Date d'effet :</strong>{" "}
                      {droit.datedEffet?.split("T")[0] || "—"}
                    </p>
                    <p>
                      <strong>Sort :</strong> {droit.sort || "—"}
                    </p>
                    <p>
                      <strong>Clause :</strong> {droit.clause || "—"}
                    </p>
                    <p>
                      <strong>Commentaire :</strong> {droit.commentaire || "—"}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        <button className="close-btn" onClick={onClose}>
          Fermer
        </button>
      </div>
    </div>
  );
}

export default MissionPopup;
